import KbArticleRtfContent from './kb-article-rtf-content';

export default KbArticleRtfContent;
